import React, { useEffect, useState } from "react";
import TopTitleBanner from "../component/TopTitleBanner";
import "../css/dashboard.css";
import "../css/setting.css";
import { useAuth } from "../contexts/AuthContext";
import "react-toastify/dist/ReactToastify.css";
import "react-tippy/dist/tippy.css";
import { roles } from "../firebase.collection";
import { documentId, onSnapshot, query, where } from "firebase/firestore";
import EmailTemplateEditor from "./EmailTemplateEditor";

export default function EmailTemplateContent1() {
  const [userRole, setUserRole] = useState("");

  const { currentUser } = useAuth();

  const userIdState = currentUser ? currentUser.uid : "";

  // useEffect(() => {
  //   if (currentUser?.email) {
  //     recordMetrics("Roles", "pageLoad", currentUser.email, "read", "bodhi");
  //   }
  // }, [currentUser.email]);


  useEffect(() => {
    if (currentUser) {
      queryRole();
    } else {
      console.log("No user id");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentUser]);

  function queryRole() {
    onSnapshot(
      query(roles, where(documentId(), "==", userIdState)),
      (querySnapshot) => {
        const doc = querySnapshot.docs[0];
        if (doc && doc.exists) {
          const role = doc.data().role;

          setUserRole(role);
        } else {
          console.log("No role for this user");
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
      }
    );
  }

  const isSuperAdmin =
    userRole === "Super Admin" || userRole === "Clinical Director";



  return (
    <div className="right-container-settings">
      {isSuperAdmin ? (
        <>
          <div className="admin-panel">
            <TopTitleBanner title={"Moving to Incoming Mail Template"} />
          </div>
          <div style={{ paddingLeft: "40px", paddingRight: "40px" }}>
            <EmailTemplateEditor />
          </div>
        </>
      ) : (
        <div>
          <TopTitleBanner title={"Email Templates Management"} />
          <p style={{ marginLeft: "60px", color: "red", fontWeight: "bold " }}>
            --You don't have Super-admin credentials to access this page--
          </p>
        </div>
      )}
    </div>
  );
}
